var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Item"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8744 3C17.3835 3 16.9855 3.39465 16.9855 3.88148V8.08084C16.9855 8.56767 17.3835 8.96232 17.8744 8.96232C18.3653 8.96232 18.7633 8.56767 18.7633 8.08084V3.88148C18.7633 3.39465 18.3653 3 17.8744 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7633 8.08084C18.7633 7.59401 18.3653 7.19936 17.8744 7.19936H13.6398C13.1488 7.19936 12.7509 7.59401 12.7509 8.08084C12.7509 8.56767 13.1488 8.96232 13.6398 8.96232H17.8744C18.3653 8.96232 18.7633 8.56767 18.7633 8.08084Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.8963C14.1307 5.8963 16.0074 6.95672 17.1288 8.5792C17.4064 8.98075 17.9596 9.08315 18.3646 8.80792C18.7695 8.53268 18.8728 7.98403 18.5952 7.58248C17.1567 5.5012 14.742 4.13333 12 4.13333C7.58251 4.13333 4 7.68599 4 12.0667C4 16.4473 7.58251 20 12 20C16.4175 20 20 16.4473 20 12.0667C20 11.5798 19.602 11.1852 19.1111 11.1852C18.6202 11.1852 18.2222 11.5798 18.2222 12.0667C18.2222 15.4737 15.4356 18.237 12 18.237C8.56435 18.237 5.77778 15.4737 5.77778 12.0667C5.77778 8.65965 8.56435 5.8963 12 5.8963Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineReload);
export default __webpack_public_path__ + "static/media/line-reload.693bdceff1bc6cd9b993b266a5706786.svg";
export { ForwardRef as ReactComponent };